import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: "/assets/i18n/{{ns}}/{{lng}}.json",
    },
    fallbackLng: "en",
    debug: false,
    ns: [
      "sidebar",
      "parentclient",
      "header",
      "createClassRequest",
      "rosterSearch",
      "rescheduleTransfer",
      "rosterConfig",
      "classRequestDrawer",
      "bulkEditHeader",
      "attendance",
      "employee",
      "employeeEquip",
      "employeeTicket",
      "class",
      "statusDisposition",
      "statusOveride",
      "ACC",
      "TCI",
      "TPC",
      "productTraining",
      "TTF",
      "TTD",
      "AttachmentDrawer",
    ],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      formatSeparator: ",",
    },
    react: {
      wait: true,
    },
  });

export default i18n;
